import { createContext } from 'react';
const ModalContext = /*#__PURE__*/createContext({
  show: () => {},
  close: () => {}
});
export default ModalContext;